import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useBrand = () => {
  return useQuery({
    queryKey: ["brand"],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("Not authenticated");

      const { data, error } = await supabase
        .from("brands")
        .select(`
          *,
          current_plan:plans(*)
        `)
        .eq("owner_id", user.id)
        .single();

      if (error) throw error;
      return data;
    },
  });
};